import Vue from 'vue'
import App from './App.vue'
import vantPlugin from './plugins/vant.plugin';
import hmPlugin from './plugins/hm.plugin';
import components from './components'
import router from './router/index'
import constants from './constants';
import store from './store';
import api from './api'
import 'vant/lib/index.css';
import './assets/css/common.less'
import Cookies from 'js-cookie';
import device from '@/utils/device';
import Toast from 'vant/lib/toast';
import { initial } from 'lodash';
import Storage from '@/utils/storage'
import filters from './utils/filters'
import '@vant/touch-emulator';
import './utils/rem'
import loadCaptchaPlugin from './plugins/captcha';
import { mapInit } from './utils/map';

Vue.use(vantPlugin)
Vue.prototype.$const = constants;
Vue.prototype.$api = api
Object.keys(components).forEach(key => {
  Vue.component(key, components[key]);
});
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key]);
})
async function getWxConfig(signUrl) {
  try {
    const res = await api.getSign({ url: encodeURIComponent(signUrl) });
    wx.config({
      debug: false,
      ...res,
      jsApiList: [
        'onMenuShareTimeline',
        'onMenuShareAppMessage',
        'updateAppMessageShareData',
        'updateTimelineShareData',
        'getLocation',
        'openLocation',
      ],
    });
    wx.ready(() => {
      console.log('微信 jssdk 初始化成功');
    });
    wx.error(err => {
      throw new Error('微信 jssdk 初始化失败' + err.errMsg);
    });
  } catch (err) {
    Toast(err.message);
  }
}
const initApp = async () => {
  try {
    await Promise.all([store.dispatch('getDict'), store.dispatch('getUserInfo'),store.dispatch('setCaptchaConfig')])
  } catch (err) {
    // console.log(err)
  }
  const webConfig = await store.dispatch('getWebConfig')
  if (webConfig.baidu_tongji) {
    Vue.use(hmPlugin, { id: webConfig.baidu_tongji });
  }
  if (webConfig.captcha === 2) {
    Vue.use(loadCaptchaPlugin);
  }

  await mapInit(webConfig);

  router.beforeEach((to, from, next) => {
    const userType = Storage.get('user_type')
    const token = sessionStorage.getItem('token') || Cookies.get('token') || Storage.get('token');
    const isCompany = Boolean(token && Number(userType) === 2)

    if (isCompany && !webConfig.odd_jobs_is_talent && (to.name === 'projectManage' || to.name === 'oddPublish')) {
      if (to.name === 'oddPublish') {
        window.location.href = `${window.location.protocol}//${webConfig.url}/seekwap/recruit/publish?token=${token}`;
        return
      }
      window.location.href = `${window.location.protocol}//${webConfig.url}/seekwap?token=${token}`;
      return
    } else if (webConfig.odd_jobs_application) {
      if (to.name === 'error') {
        next({ path: '/' });
      } else if (to.meta.needLogin && !token && to.name !== 'login') {
        next({ path: '/login' });
      } else if (to.meta.userType && !to.meta.userType.includes(Number(userType))) {
        next({ path: '/' });
      } else {
        next();
      }
    } else if (to.name !== 'error') {
      next({ path: '/error' });
    } else {
      next()
    }

  })

  router.afterEach(to => {
    // 非微信环境内不初始化jssdk
    if (!device.isWechat) {
      return;
    }
    if (device.isIOS) {
      // IOS
      if (window.entryUrl === '' || window.entryUrl == undefined) {
        window.entryUrl = location.href.split('#')[0]
      }
      getWxConfig(window.entryUrl);
    } else {
      // Android
      setTimeout(function () {
        getWxConfig(`${window.location.origin}${process.env.VUE_APP_DEBUG === '0' ? '/odd' : '/odd'}${to.fullPath}`);
      }, 1000);
    }
  });

  new Vue({
    router,
    store,
    render: h => h(App),
  }).$mount('#app')
}
initApp()
